export default function RedNotification() {
  return (
    <div className="notification-dot-only-container">
      <span className="notification-dot-only"></span>
    </div>
  )
}